// Taken from https://github.com/wix-private/media-manager-js-sdk/blob/master/src/dto/media-type.js
export var MediaType;
(function (MediaType) {
    MediaType["AUDIO"] = "music";
    MediaType["VIDEO"] = "video";
    MediaType["IMAGE"] = "picture";
    MediaType["SECURE_IMAGE"] = "secure_picture";
    MediaType["DOCUMENT"] = "document";
    MediaType["STATIC"] = "static_file";
})(MediaType || (MediaType = {}));
export const MEDIA_SERVICES_URL = '/_serverless/ricos-media-services';
//# sourceMappingURL=consts.js.map